export const accessTokenKey = 'ent-regis-access-token';
export const refreshTokenKey = 'ent-regis-refresh-token';